module.exports = __webpack_public_path__ + "img/30120a1.jpg";